module.exports = "/_next/static/images/money-63d960d38299eb93bfbe9560fb83ef2f.svg";